import React from "react";
import { FaRegPlayCircle } from "react-icons/fa";

const VideoThumbnail = ({ src }) => {
  const tileStyle = {
    width: "100px",
    height: "100px",
    backgroundColor: "black",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const playButtonStyle = {
    color: "white",
    fontSize: "40px",
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out", // Add smooth transition
  };

  const handlePlayClick = () => {
    // Open the link in a new tab
    window.open(src, "_blank", "noopener,noreferrer");
  };

  return (
    <div style={tileStyle}>
    <FaRegPlayCircle
      style={playButtonStyle}
      onClick={handlePlayClick}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")} // Enlarge on hover
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} // Reset on hover out
    />
  </div>
  );
};

export default VideoThumbnail;